<template>
  <div>
    <h3 style="margin-left:15px; margin-top:20px;">Imagens</h3>
    <v-list-item
      style="margin-top:20px;"
      :to="{ path: link, query: { item, num, description } }"
    >
      <v-list-item-content>
        <v-img
          @click="num = i"
          v-for="(itemImage, i) in items"
          :key="i"
          :src="require(`../../../../styles/${item[i]}`)"
          style="height:200px; max-width:200px; margin:10px;"
        ></v-img>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Number,
      required: true
    },
    item: {
      type: Array,
      required: true
    },
    description: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      num: 0,
      link: "/imagem"
    };
  }
};
</script>
